module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-title@3x-be28a3e98b55d046484215a43291efa9.png";